// extracted by mini-css-extract-plugin
export default {"box":"uploader_box__ayUpT","inner":"uploader_inner__JTw9Y","progress":"uploader_progress__q3cyp"};